import { getRequest, postRequest } from '@bo-apis/axios';

const getCommonCode = (code) =>
  getRequest({
    url: `api/v1/system/code/${code}/get-code`,
  });

const getCommonCodeByName = (name) =>
  getRequest({
    url: `api/v1/system/code/${name}/get-code-by-name`,
  });

const getCommonCodeList = ({ form, pageable }) =>
  postRequest({
    url: 'api/v1/system/code/get-code-list',
    params: { ...pageable },
    data: { ...form },
  });

const saveCommonCodeGridData = (gridData) =>
  postRequest({
    url: 'api/v1/system/code/save-code-data',
    data: { ...gridData },
  });

const saveCommonCodeDetailGridData = (gridData) =>
  postRequest({
    url: 'api/v1/system/code/save-detail-data',
    data: { ...gridData },
  });

const getCodeDetailList = (commonCode, skip = {}) =>
  getRequest(
    {
      url: `/api/v1/system/code/${commonCode}/get-detail-list`,
    },
    skip
  );

export default {
  getCommonCode,
  getCommonCodeList,
  saveCommonCodeGridData,
  saveCommonCodeDetailGridData,
  getCodeDetailList,
  getCommonCodeByName,
};
